export const ENHANCED_EVENT_TICKET_IMAGE_LABELS: Record<
  'artwork' | 'secondaryLogo' | 'venueMap',
  string
> = {
  artwork: 'Artwork',
  secondaryLogo: 'Secondary logo',
  venueMap: 'Venue map',
};
